import { t } from "../utils/i18n";

export const Header = ({ onToggleLang, lang, userName, onLogout }) => (
  <header className="header">
    <div className="header-top">
      <div className="header-brand">
        <span>🌯</span> Kebatic
      </div>
      <button onClick={onToggleLang} className="lang-button" type="button">
        {lang === "lt" ? "EN" : "LT"}
      </button>
    </div>
    <p className="header-subtitle" data-i18n="add_order_title">
      Pridėti kebabo užsakymą
    </p>
    {userName && onLogout && (
      <div className="header-user">
        <span>{userName}</span>
        <button type="button" className="btn-logout" onClick={onLogout}>
          {t(lang, "logout_btn")}
        </button>
      </div>
    )}
  </header>
);

export default Header;
